import { addMinutes } from "date-fns";
import { FieldValues } from "react-hook-form";
import { ChronicleFilenamesEnum, PlanningModeEnum } from "shared/enums/globalEnums";

export interface PlanningConfig {
  name: string;
  durationInMinutes: number;
  chronicleFilename?: ChronicleFilenamesEnum;
  reactivityDelay?: number;
  socPercentage?: number;
  mode: PlanningModeEnum;
}

export const planningConfigurations: PlanningConfig[] = [
  {
    name: "Fr MSI JBOX2 1 Dynamic Test 10min",
    durationInMinutes: 10,
    chronicleFilename: ChronicleFilenamesEnum.fr_msi_jbox2_1_dynamic_test_10min,
    reactivityDelay: 0,
    mode: PlanningModeEnum.power,
  },
  {
    name: "SoC Management 1",
    durationInMinutes: 15,
    socPercentage: 40,
    mode: PlanningModeEnum.soc_management,
  },
  {
    name: "Fr MSI JBOX2 2 Scale Withdrawing Test 130min",
    durationInMinutes: 130,
    chronicleFilename: ChronicleFilenamesEnum.fr_msi_jbox2_2_scale_withdrawing_test_130min,
    reactivityDelay: 0,
    mode: PlanningModeEnum.power,
  },
  {
    name: "SoC Management 2",
    durationInMinutes: 130,
    socPercentage: 100,
    mode: PlanningModeEnum.soc_management,
  },
  {
    name: "Fr MSI JBOX2 4 Injection Test Pmax 130min",
    durationInMinutes: 130,
    chronicleFilename: ChronicleFilenamesEnum.fr_msi_jbox2_4_injection_test_pmax_130min,
    reactivityDelay: 0,
    mode: PlanningModeEnum.power,
  },
  {
    name: "SoC Management 3",
    durationInMinutes: 180,
    socPercentage: 0,
    mode: PlanningModeEnum.soc_management,
  },
  {
    name: "Fr MSI JBOX2 6 Withdrawing Test Pmax 145min",
    durationInMinutes: 145,
    chronicleFilename: ChronicleFilenamesEnum.fr_msi_jbox2_6_withdrawing_test_pmax_145min,
    reactivityDelay: 0,
    mode: PlanningModeEnum.power,
  },
  {
    name: "SoC Management 4",
    durationInMinutes: 195,
    socPercentage: 100,
    mode: PlanningModeEnum.soc_management,
  },
  {
    name: "Fr MSI JBOX2 8 Injection Test 1000kW 145min",
    durationInMinutes: 145,
    chronicleFilename: ChronicleFilenamesEnum.fr_msi_jbox2_8_injection_test_1000kw_145min,
    reactivityDelay: 0,
    mode: PlanningModeEnum.power,
  },
  {
    name: "SoC Management 5",
    durationInMinutes: 180,
    socPercentage: 0,
    mode: PlanningModeEnum.soc_management,
  },
  {
    name: "Fr MSI JBOX2 10 Withdrawing Test 1000kW 155min",
    durationInMinutes: 155,
    chronicleFilename: ChronicleFilenamesEnum.fr_msi_jbox2_10_withdrawing_test_1000kW_155min,
    reactivityDelay: 0,
    mode: PlanningModeEnum.power,
  },
  {
    name: "SoC Management 6",
    durationInMinutes: 120,
    socPercentage: 95,
    mode: PlanningModeEnum.soc_management,
  },
  {
    name: "Fr MSI JBOX2 12 Scale Injection Test 95min",
    durationInMinutes: 95,
    chronicleFilename: ChronicleFilenamesEnum.fr_msi_jbox2_12_scale_injection_test_95min,
    reactivityDelay: 0,
    mode: PlanningModeEnum.power,
  },
  {
    name: "SoC Management 7",
    durationInMinutes: 30,
    socPercentage: 50,
    mode: PlanningModeEnum.soc_management,
  },
];

export const computeDefaultValues = (initialData: FieldValues) => {
  return planningConfigurations.reduce((acc: Record<string, any>, currentConfig: PlanningConfig, index: number) => {
    const initialPlanning = index === 0;
    const prevPlanning = index > 0 ? planningConfigurations[index - 1] : null;
    const prevEndDate = prevPlanning ? acc[prevPlanning.name].end_date : null;

    const start_date = initialPlanning ? new Date(initialData.startDate) : prevEndDate;
    const end_date = addMinutes(start_date, currentConfig.durationInMinutes);
    const planningDefaults = {
      active: true,
      start_date,
      end_date,
      mode: currentConfig.mode,
      chronicleFilename: currentConfig.chronicleFilename,
      reactivityDelay: currentConfig.reactivityDelay,
      socPercentage: currentConfig.socPercentage,
    };

    return { ...acc, [currentConfig.name]: planningDefaults };
  }, {});
};
